// extracted by mini-css-extract-plugin
export default {"servicesList":"ServicesContainer_servicesList__-WWMk","heading":"ServicesContainer_heading__iFOQH","banner":"ServicesContainer_banner__VuCRE"};